module.exports = __webpack_public_path__ + "img/prog_layout2.e034f51e.png";